<template>
  <div class="layout" :class="{ pcLayout: isPcNav }">
    <!-- 桌面端顶部 Header 导航(替代移动端底部 tabbar); 仅默认永利皮肤 newGameUIType===0 -->
    <header v-if="isPcNav" class="pcHeader">
      <div class="pcHeaderInner">
        <img class="pcLogo" :src="logoBiao" alt="logo"/>
        <nav class="pcNav">
          <div
              v-for="item in pcNavItems"
              :key="item.name"
              class="pcNavItem"
              :class="{ active: active === item.name }"
              @click="tabChange(item.name)"
          ><span class="pcNavLabel">{{ item.label }}</span></div>
        </nav>
        <div class="pcHeaderRight">
          <template v-if="userStore.isLogin">
            <!-- VIP/洗码/福利/充值/提现 图标按钮 (搬自首页公告下面那一行) -->
            <div class="pcActionBtns">
              <div v-for="item in pcActionBtns" :key="item.title" class="pcActionBtn"
                   @click="clickActionBtn(item.route)">
                <img :src="item.icon" alt=""/>
                <span>{{ item.title }}</span>
              </div>
            </div>
            <!-- 昵称 + VIP 等级 + 余额, 放在最右侧 (搬自首页公告下面那一行)。
                 只有"昵称+VIP"这一行点击进 VIP 页; 余额的刷新按钮点击不再冒泡触发跳转。 -->
            <div class="pcUserBox">
              <div class="pcUserLine" @click="hr.go('vip')">
                <span class="pcUserName">{{ hcf.getShowNamePhoneId(userStore) }}</span>
                <img class="pcVipFlag" :src="vipFlagIcon" alt=""/>
              </div>
              <HShowRefreshBalance :imgSize="16"/>
            </div>
          </template>
          <div v-else class="pcLoginBtn" @click="hr.go('login')">登录 / 注册</div>
        </div>
      </div>
    </header>

    <div class="tabScrollArea"
         :class="{ tabBgWhite: active==='home' && HNewGameUIConfig.newGameUIType===0 }"
         :style="{
      paddingBottom: (!isPcNav && HNewGameUIConfig.newGameUIType === 0) ? '50px' : '0',
    }
    ">
      <!-- 移动端必须撑满高度(height:100%), 否则会打断内页(如首页游戏区)"填满一屏+内部滚动"
           所依赖的 height:100% 链, 导致游戏区撑成全内容高、无法内部滚动。桌面走整页滚动, 高度交给内容。 -->
      <!-- 桌面统一居中定宽(含非 main 包网): 原来只有 main(isPcNav)套 .pc-container, 非 main 包网
           内容铺满整屏, 导致首页游戏区按内容宽(1200)算的图标在超宽屏下左对齐、右侧留白/多挤出列。
           改为所有桌面都居中限宽, 游戏区/banner/吸顶头部随之整体居中。 -->
      <div :class="{ 'pc-container': isDesktop }" :style="{ height: isDesktop ? undefined : '100%' }">
        <router-view v-slot="{ Component }">
          <keep-alive>
            <component :is="Component"/>
          </keep-alive>
        </router-view>
      </div>
    </div>

    <van-tabbar v-if="HNewGameUIConfig.newGameUIType === 0 && !isPcNav" ref="tabBarRef" safe-area-inset-bottom v-model="active"
                @change="tabChange"
                active-color="#6B7FF7FF"
                inactive-color="#5C6293">
      <van-tabbar-item name="home">
        首页
        <template #icon="props">
          <img :src="props.active ? home_p : home_n" alt=""/>
        </template>
      </van-tabbar-item>
      <van-tabbar-item name="reward" :dot="hasClaimableActivity">
        福利
        <template #icon="props">
          <img :src="props.active ? discount_p : discount_n" alt=""/>
        </template>
      </van-tabbar-item>
      <van-tabbar-item name="recharge">
        充值
        <template #icon="props">
          <img :src="props.active ? pay_p : pay_n" alt=""/>
        </template>
      </van-tabbar-item>
      <van-tabbar-item name="bet-his">
        注单
        <template #icon="props">
          <img :src="props.active ? betHistory_p : betHistory_n" alt=""/>
        </template>
      </van-tabbar-item>
      <van-tabbar-item name="my">
        我的
        <template #icon="props">
          <img :src="props.active ? my_p : my_n" alt=""/>
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>


<script setup>
  import home_n from '@/assets/icons/tabs/home_n.png';
  import home_p from '@/assets/icons/tabs/home_p.png';
  import discount_n from '@/assets/icons/tabs/preferential_n.png';
  import discount_p from '@/assets/icons/tabs/preferential_p.png';
  import pay_n from '@/assets/icons/tabs/pay_n.png';
  import pay_p from '@/assets/icons/tabs/pay_p.png';
  import betHistory_n from '@/assets/icons/tabs/bethistory_n.png';
  import betHistory_p from '@/assets/icons/tabs/bethistory_p.png';
  import my_n from '@/assets/icons/tabs/my_n.png';
  import my_p from '@/assets/icons/tabs/my_p.png';
  import logoBiao from '@/assets/icons/logo_biao.png';
  import {useRoute} from "vue-router";
  import {hr} from "@/components/utils/HRouter.js";
  import {useUserStore} from "@/stores/useUser.js";
  import {emitter, hcf} from "@/components/utils/HComFunctions.js";
  import {hdi} from "@/components/utils/HDeviceInfo.js";
  import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";
  import {useHComApi} from "@/hooks/useHComApi.js";
  import {useResponsive} from "@/hooks/useResponsive.js";
  import HShowRefreshBalance from "@/components/utils/HShowRefreshBalance.vue";

  const {hasClaimableActivity} = useHComApi();

  // 桌面端导航
  const {isDesktop} = useResponsive();
  const userStore = useUserStore();
  const isPcNav = computed(() => isDesktop.value && HNewGameUIConfig.newGameUIType === 0);
  const pcNavItems = [
    {name: 'home', label: '首页'},
    {name: 'reward', label: '福利'},
    {name: 'recharge', label: '充值'},
    {name: 'bet-his', label: '注单'},
    {name: 'my', label: '我的'},
  ];

  // 顶部 Header 右侧: VIP 等级图标 + VIP/洗码/福利/充值/提现 按钮 (搬自首页公告下面那一行)
  const vipFlagIcon = computed(() => hcf.getNewGameUIIcon(`vip_flag_icon_${userStore.vipLevel}.png`));
  const pcActionBtns = [
    {title: 'VIP', route: 'vip', icon: hcf.getNewGameUIIcon('youxivip.png')},
    {title: '洗码', route: 'xima', icon: hcf.getNewGameUIIcon('huodong.png')},
    {title: '福利', route: 'reward', icon: hcf.getNewGameUIIcon('fanshui.png')},
    {title: '充值', route: 'pay', icon: hcf.getNewGameUIIcon('chongzhi.png')},
    {title: '提现', route: 'withdraw', icon: hcf.getNewGameUIIcon('tixian.png')},
  ];
  function clickActionBtn(routeName) {
    // 与首页原 clickMiddleBtn 行为一致: 福利走 tab, 其余走登录校验后跳转
    if (routeName === 'reward') {
      tabChange('reward');
      return;
    }
    userStore.checkIsLoginGo(routeName);
  }

  let route = useRoute();
  const active = computed(() => route.name || 'home');

  function tabChange(name) {
    window.scrollTo({
      top: -10,
    });
    if (!useUserStore().isLogin && ["reward", "recharge", "bet-his"].includes(name)) {
      hr.go("login");
    } else {
      hr.go(name);
    }
  }

  const tabBarRef = ref(null);

  onMounted(() => {
    const el = tabBarRef.value?.$el;
    if (el) {
      el.addEventListener('dblclick', (e) => {
        e.preventDefault();
      });
    }
    // 暂时刷新必须从Home进入
    // active.value = route.name;
    emitter.on("HOME_BOTTOM_TAB_CHANGE", (tabIndex) => {
      switch (tabIndex) {
        case 0:
          tabChange("home");
          break;
        case 1:
          tabChange("reward");
          break;
        case 2:
          tabChange("recharge");
          break;
        case 3:
          tabChange("bet-his");
          break;
        case 4:
          tabChange("my");
          break;
      }
    });
  });

</script>


<style scoped>
  .layout {
    display: flex;
    flex-direction: column;
    /* 跟随已锁定的 body 实际视口高度(用 100vh 在 iOS 会含 Safari 工具栏区, 底部 tab/内容被裁) */
    height: 100%;
    overflow: hidden; /* 锁住整页, 让滚动只发生在内部容器, 顶部不被整体拖动 */
  }

  /* tab 内容区: 唯一的滚动容器。首页内容正好填满则不滚(顶部固定, 仅游戏区内部滚动);
     其它较长的 tab 页在此容器内滚动, 而不是滚动整个 body。 */
  .tabScrollArea {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
  }

  /* 永利首页: 底部给 tabbar 预留的 padding 区填白, 与游戏区白色连成一片, 不露底色 */
  .tabBgWhite {
    background-color: #fff;
  }

  /* ===== 桌面端顶部 Header 导航 (仅 >=1024px 生效, px 为真实像素) ===== */
  @media (min-width: 1024px) {
    /* 内容区两侧留白露出页面底色 */
    .pcLayout .tabScrollArea {
      background: var(--pc-page-bg);
    }

    .pcHeader {
      flex: 0 0 auto;
      height: var(--pc-header-h);
      background: var(--ct-main-container-bg-color, #fff);
      border-bottom: 1px solid rgba(0, 0, 0, 0.06);
      box-shadow: 0 1px 6px rgba(0, 0, 0, 0.04);
      position: relative;
      z-index: 20;
    }

    .pcHeaderInner {
      height: 100%;
      max-width: var(--pc-content-w);
      margin: 0 auto;
      /* logo 左缘 / 金额右缘就落在这段内边距处; 其它内容用 --pc-content-inset-x 对齐到此 */
      padding: 0 var(--pc-header-pad-x);
      display: flex;
      align-items: center;
      box-sizing: border-box;
    }

    .pcLogo {
      height: 34px;
      width: auto;
      margin-right: 28px;
      flex: 0 0 auto;
    }

    .pcNav {
      display: flex;
      align-items: center;
      height: 100%;
      gap: 2px;
    }

    .pcNavItem {
      height: 100%;
      display: flex;
      align-items: center;
      padding: 0 18px;
      font-size: 16px;
      color: var(--ct-main-font-color, #333);
      cursor: pointer;
      position: relative;
      transition: color 0.15s;
      white-space: nowrap;
    }

    .pcNavItem:hover {
      color: var(--ct-main-color);
    }

    .pcNavItem.active {
      color: var(--ct-main-color);
      font-weight: 600;
    }

    /* 选中下划线: 贴着标题文字底部下方 ~5px(而不是钉在 64px 高的 Header 最底部) */
    .pcNavLabel {
      position: relative;
    }

    .pcNavItem.active .pcNavLabel::after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      bottom: -5px;
      height: 3px;
      border-radius: 3px;
      background: var(--ct-main-color);
    }

    .pcHeaderRight {
      margin-left: auto;
      display: flex;
      align-items: center;
      gap: 16px;
    }

    /* 昵称 + VIP 图标 + 余额 (竖排) */
    .pcUserBox {
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 2px;
      max-width: 160px;
    }

    .pcUserLine {
      display: flex;
      align-items: center;
      gap: 3px;
      cursor: pointer;
    }

    .pcUserName {
      font-size: 13px;
      color: #888;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 120px;
    }

    .pcVipFlag {
      height: 16px;
      width: auto;
      flex: 0 0 auto;
    }

    /* VIP/洗码/福利/充值/提现 图标按钮行 */
    .pcActionBtns {
      display: flex;
      align-items: center;
      gap: 4px;
    }

    .pcActionBtn {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 2px;
      padding: 2px 6px;
      border-radius: 8px;
      cursor: pointer;
      transition: background 0.15s;
    }

    .pcActionBtn:hover {
      background: rgba(0, 0, 0, 0.04);
    }

    .pcActionBtn img {
      height: 26px;
      width: auto;
    }

    .pcActionBtn span {
      font-size: 11px;
      color: #555;
      white-space: nowrap;
    }

    .pcLoginBtn {
      height: 36px;
      padding: 0 18px;
      border-radius: 18px;
      display: flex;
      align-items: center;
      background: var(--ct-main-color);
      color: #fff;
      font-size: 14px;
      cursor: pointer;
      white-space: nowrap;
      user-select: none;
    }

    .pcLoginBtn:hover {
      opacity: 0.9;
    }
  }
</style>
